import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IInitialState {
    louncherInstallerLoading: boolean;
    louncherInstallerData: Blob | null;
    louncherInstallerError: string;
}

const initialState: IInitialState = {
    louncherInstallerLoading: false,
    louncherInstallerData: null,
    louncherInstallerError: '',
};

const downloadSlice = createSlice({
    name: 'download',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchLouncherInstallerPending: (state: IInitialState, action: PayloadAction<string>) => {
            state.louncherInstallerLoading = true;
            state.louncherInstallerData = null;
            state.louncherInstallerError = '';
        },

        fetchLouncherInstallerFulfilled: (state: IInitialState, action: PayloadAction<Blob>) => {
            state.louncherInstallerLoading = false;
            state.louncherInstallerData = action.payload;
            state.louncherInstallerError = '';
        },

        fetchLouncherInstallerFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.louncherInstallerLoading = false;
            state.louncherInstallerData = null;
            state.louncherInstallerError = action.payload;
        },
    },
});

export default downloadSlice.reducer;
export const { fetchLouncherInstallerPending, fetchLouncherInstallerFailure, fetchLouncherInstallerFulfilled } = downloadSlice.actions;
